(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/input-number/assets/javascripts/input-number.js') >= 0) return;  svs.modules.push('/components/components/input-number/assets/javascripts/input-number.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

(function (svs) {
  const _svs$components$input = svs.components.input_number.utils,
    isNumber = _svs$components$input.isNumber,
    getValidValue = _svs$components$input.getValidValue,
    isWithinBounds = _svs$components$input.isWithinBounds;
  function inputNumber(_ref) {
    let el = _ref.el,
      _ref$onValueChange = _ref.onValueChange,
      onValueChange = _ref$onValueChange === void 0 ? () => {} : _ref$onValueChange;
    if (!el) {
      throw new Error('el is not defined');
    }
    const _svs$components$input2 = svs.components.input_number.constants,
      CLASS_ERROR = _svs$components$input2.CLASS_ERROR,
      TOGGLE_ERROR_TIMEOUT = _svs$components$input2.TOGGLE_ERROR_TIMEOUT,
      CLASS_INPUT = _svs$components$input2.CLASS_INPUT,
      CLASS_BUTTONS = _svs$components$input2.CLASS_BUTTONS;
    const buttonClass = "js-".concat(CLASS_BUTTONS);
    const inputClass = "js-".concat(CLASS_INPUT);
    const _el$querySelectorAll = el.querySelectorAll(".".concat(buttonClass)),
      _el$querySelectorAll2 = _slicedToArray(_el$querySelectorAll, 2),
      decBtn = _el$querySelectorAll2[0],
      incBtn = _el$querySelectorAll2[1];
    const input = el.querySelector(".".concat(inputClass));
    let value = input.valueAsNumber;
    let previousValue = input.valueAsNumber;
    let lastSubmittedValue = input.valueAsNumber;
    if (typeof value === 'undefined') {
      value = previousValue = lastSubmittedValue = input.value = 1;
    }
    const settings = {
      minValue: Number(input.getAttribute('min')) || -Infinity,
      maxValue: Number(input.getAttribute('max')) || Infinity,
      negativeStep: Number(decBtn.dataset.step) || -1,
      positiveStep: Number(incBtn.dataset.step) || 1
    };
    const _onValueChange = _ref2 => {
      let target = _ref2.target,
        type = _ref2.type;
      if (target.classList.contains(buttonClass) || type === 'input') {
        const step = Number(target.dataset.step);
        const newValue = isNaN(step) ? target.valueAsNumber : value + step;
        if (isNumber(newValue) || target.value === '') {
          const validValue = updateValue(newValue, type);
          if (isNumber(newValue)) {
            if (lastSubmittedValue !== validValue && (isWithinBounds(newValue, settings) || ~[settings.maxValue, settings.minValue].indexOf(validValue))) {
              onValueChange(validValue);
              lastSubmittedValue = validValue;
            }
            validValue !== newValue && onError();
            previousValue = validValue;
          }
        } else {
          onError();
        }
      }
    };
    const _onBlur = () => {
      if (!isNumber(value) || !isWithinBounds(value, settings)) {
        const validValue = updateValue(previousValue);
        if (lastSubmittedValue !== validValue) {
          onValueChange(validValue);
          lastSubmittedValue = validValue;
        }
      }
    };
    const _onFocus = _ref3 => {
      let target = _ref3.target;
      target.select && target.select();
      previousValue = value;
    };
    const updateValue = (newValue, type) => {
      const validValue = getValidValue(newValue, previousValue, settings);
      value = input.value = isNumber(newValue) ? newValue < validValue && type !== 'click' ? newValue : validValue : '';
      decBtn.disabled = !(value > settings.minValue);
      incBtn.disabled = !(value < settings.maxValue);
      return validValue;
    };
    const onError = () => {
      el.classList.add(CLASS_ERROR);
      setTimeout(() => el.classList.remove(CLASS_ERROR), TOGGLE_ERROR_TIMEOUT);
    };
    updateValue(value);
    el.addEventListener('click', _onValueChange, false);
    input.addEventListener('input', _onValueChange, false);
    input.addEventListener('focus', _onFocus, false);
    input.addEventListener('blur', _onBlur, false);
    const destroy = () => {
      el.removeEventListener('click', _onValueChange);
      input.removeEventListener('input', _onValueChange);
      input.removeEventListener('focus', _onFocus);
      input.removeEventListener('blur', _onBlur);
    };
    return {
      destroy,
      getValue() {
        return value;
      }
    };
  }
  svs.components.input_number.inputNumber = inputNumber;
})(svs);

 })(window);